// @flow
import Record from "../flow/Record";
import { List } from "immutable";
import { Post } from "./post.record";

export class RequestState extends Record({
    requesting: false,
    errors: List()
}) {
    requesting: boolean;
    errors: List<string>;
}

export function jsToEdgeRecord(conversionFunc: (t: any) => any) {
    return ({ cursor, node }: { cursor: any, node: any }): Edge<Post> =>
        new Edge({
            cursor,
            node: conversionFunc(node)
        });
}

export class Edge<T> extends Record({
    cursor: null,
    node: (null: any)
}) {
    cursor: ?string;
    node: T;
}

export class PageInfo extends Record({
    endCursor: null,
    hasNextPage: true
}) {
    endCursor: ?string;
    hasNextPage: boolean;
}

export class PagedRequest extends Record({
    request: new RequestState(),
    edges: List(),
    pageInfo: new PageInfo(),
    totalCount: 0
}) {
    request: RequestState;
    edges: List<Edge<*>>;
    pageInfo: PageInfo;
    totalCount: 0;
}



// WEBPACK FOOTER //
// ./src/records/request.record.js